

















































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {groupParams, isAnimatedParam, displayName} from '@/params'
import type {ParamStore} from '@/store/paramstore'
import {shotStore} from '@/store'
import ColorInputInlineMini from '@/components/ColorInputInlineMini.vue'
import NumberInput from '@/components/NumberInput.vue'
import RotationParam from '@/components/RotationParam.vue'
import VectorParam from '@/components/VectorParam.vue'
import ParamAutokeyIcon from './ParamAutokeyIcon.vue'
import ParamKeyframeIcon from './ParamKeyframeIcon.vue'
import SelectionParamHint from '@/components/NGL/SelectionParamHint.vue'

@Component({
  components: {
    ColorInputInlineMini,
    NumberInput,
    RotationParam,
    VectorParam,
    ParamAutokeyIcon, ParamKeyframeIcon,
    SelectionParamHint,
  }
})
export default class Params extends Vue {
  @Prop() store!: ParamStore
  // Indicates which param groups are open
  groupsOpen: {[index: string]: boolean} = {}

  get params() {
    return this.store ? groupParams(this.store.params) : []
  }

  getParam(name: string) {
    return this.store.params[name]
  }

  toggleGroup(name: string) {
    Vue.set(this.groupsOpen, name, !this.groupsOpen[name])
  }

  isGroupOpen(name: string|null) {
    return !name || this.groupsOpen[name]
  }

  // Update param value
  setParam(name: string, value: any) {
    shotStore.setSelectedParam({store: this.store, name})
    this.store.setParam({name, value})
  }

  // create or delete keyframe
  toggleKeyframe(name: string) {
    const param = this.getParam(name)
    if (isAnimatedParam(param)) {
      if (param.atKeyframe())
        this.store.removeKeyframe(name)
      else
        this.store.addKeyframe(name)
    }
  }

  /** Toggle autokey, and add keyframe at current time when turning on */
  toggleAutokey(name: string) {
    const param = this.getParam(name)
    if (isAnimatedParam(param)) {
      this.store.setAutokey({name, value: !param.autokey})
      if (param.autokey && !param.atKeyframe())
        this.store.addKeyframe(name)
    }
  }

  groupDisplayName(name: string) {
    return displayName(name)
  }

  selectParam(name: string) {
    shotStore.setSelectedParam({store: this.store, name})
  }

  // Emit event indicating param is being dragged
  startDrag(name: string) {
    shotStore.setSelectedParam({store: this.store, name})
  }

  // For non-draggable params (e.g. popups), emit the startDragEvent
  // every time they're changed.
  startDragAndSetParam(name: string, value: any) {
    shotStore.setSelectedParam({store: this.store, name})
    this.startDrag(name)
    this.setParam(name, value)
  }

  startDragAndSetParamCombo(name: string, value: any) {
    shotStore.setSelectedParam({store: this.store, name})
    this.startDrag(name)
    // Combobox params can emit either a value object with .text and
    // .value if the user chose an existing item, or a string if the
    // user typed in a string.
    if (typeof value == 'string')
      this.setParam(name, value)
    else
      this.setParam(name, value.text)
  }
}
